import { Outlet } from 'react-router-dom';
import { DashboardSidebar } from './DashboardSidebar';
import { DashboardHeader } from './DashboardHeader';
import { DashboardBottomBar } from './DashboardBottomBar';

/**
 * Layout persistant pour toutes les pages admin/dashboard.
 * La sidebar et le header ne se remontent plus à chaque navigation.
 */
export const DashboardLayout = () => {
  return (
    <div className="dashboard-body">
      <div className="dashboard-wrapper">
        <DashboardSidebar />
        <div className="dashboard-content-area">
          <DashboardHeader />
          <main className="dashboard-main">
            <Outlet />
          </main>
          <DashboardBottomBar />
        </div>
      </div>
    </div>
  );
};
